import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { ContentComponent } from "@modules/content/types";
import { useAppDispatch, useAppSelector } from "@lib/stores";
import TranslatedText from "@components/items/display/TranslatedText";
import CertificateCard from "@components/items/display/CertificateCard";
import EmptyCertificate from "@components/layouts/b2b/certificates/EmptyCertificate";
import { useEffect, useState } from "react";
import { getMyCertificatesAsync } from "@lib/stores/myLibrary/slices";
import FullCertificate from "@components/layouts/b2b/certificates/FullCertificate";
import CertificateCardSkeleton from "@components/items/display/CertificateCardSkeleton";

const Component = createComponentElement((props, ref) => {
  const dispatch = useAppDispatch();
  const [openCertificate, setOpenCertificate] = useState<boolean>(false);
  const [certificateImageUrl, setCertificateImageUrle] = useState<string>("");
  const certificates = useAppSelector(
    (state) => state.myLibrary.myCertificates.data
  );
  const certificatesStatus = useAppSelector(
    (state) => state.myLibrary.myCertificates.status
  );

  useEffect(() => {
    dispatch(getMyCertificatesAsync());
  }, [dispatch]);

  return (
    <>
      <FullCertificate
        open={openCertificate}
        setOpen={setOpenCertificate}
        imageUrl={certificateImageUrl}
      />
      <div className="cus-scrollbar-w-none w-full overflow-y-auto p-5">
        <TranslatedText
          text={`my-corner-b2b.${"certificates"}`}
          className="text-[24px] font-bold text-navy-blue dark:text-white"
        />
        {certificatesStatus !== "loading" ? (
          certificates && certificates.length > 0 ? (
            <div className="flex flex-wrap items-center justify-start gap-5 p-5">
              {certificates.map(
                ({ title, issuedAt, certificateURL }, index) => (
                  <CertificateCard
                    key={index}
                    skillName={title}
                    date={issuedAt?.split("T")[0]}
                    imagUrl={certificateURL}
                    onClick={() => {
                      setCertificateImageUrle(() => certificateURL ?? "");
                      setOpenCertificate(true);
                    }}
                  />
                )
              )}
            </div>
          ) : (
            <EmptyCertificate />
          )
        ) : (
          <div className="flex flex-wrap items-center justify-start gap-5 p-5">
            {Array.from({ length: 5 }).map(() => (
              <CertificateCardSkeleton />
            ))}
          </div>
        )}
      </div>
    </>
  );
});

export const MyCertificatesComponent: ContentComponent = {
  identifier: "COM:LIBRARY:CERTIFICATES",
  component: Component,
};
